<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardText>
        <VList dense class="pt-6 mb-0 mr-3">
          <ValidationObserver v-slot="{ handleSubmit }" ref="secondQrFormObs">
            <div class="pa-1">
              <CustomInputText
                :rules="{
                  required: true,
                }"
                clearable
                class="user_input no-margin"
                v-model="params.qrcode"
                :label="$t('enterQrCode')"
                type="text"
              ></CustomInputText>
            </div>
            <div class="text-right">
              <VBtn
                color="success"
                class="mt-2"
                @click="handleSubmit(giveProduct)"
                >{{ $t("giveOut") }}</VBtn
              >
            </div>
          </ValidationObserver>
        </VList>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
const PARAMS = {
  qrcode: null,
  orderItemId: null,
  productItemIds: [],
};
export default {
  data() {
    return {
      dialog: false,
      params: { ...PARAMS },
      data: null,
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    clear() {
      this.params = { ...PARAMS };
      this.$refs.secondQrFormObs.reset();
      this.$emit("updateTable");
    },
    async giveProduct() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get(
          `product-item/qr-code/detail/taken-away?orderItemId=${this.params.orderItemId}&productItemIds=${this.params.qrcode}`
        );
        this.data = data;
        this.close();
        this.clear();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open({ id }) {
      this.dialog = true;
      this.params.orderItemId = id;
    },
  },
};
</script>
